$(document).ready(function () {

    $('.to-up').click(function(){
        
        $('html, body').animate({ 
            scrollTop: 0
        }, 700);
    })

    $('.ask-question').click(function(){
        $('.ask-popup').fadeIn(300);
		$('.ask-popup .close-popup, .ask-blackboard').click(function(){
			$('.ask-popup').fadeOut(300);
			setTimeout(function(){
				$('.ask-content').removeClass('success');
			},300)
        })
        
    })

    $('.footer-map').click(function(){
        $('.footer-content').removeClass('show-map');       
    })

    $('.close-ask-question-block').click(function(){
        $('.footer-content').removeClass('show-form');  
    })
    
});